import { CategoryActionTypes } from './constants';

export type CategoryActionType = {
    type:
        | CategoryActionTypes.API_RESPONSE_SUCCESS
        | CategoryActionTypes.API_RESPONSE_ERROR
        | CategoryActionTypes.GET_CATEGORIES
        | CategoryActionTypes.GET_CATEGORY_TREE
        | CategoryActionTypes.GET_CATEGORY_PRODUCTS
        | CategoryActionTypes.CREATE_CATEGORY
        | CategoryActionTypes.UPDATE_CATEGORY
        | CategoryActionTypes.DELETE_CATEGORY;
    payload: {} | string;
};

// common success
export const categoryApiResponseSuccess = (actionType: string, data: any): CategoryActionType => ({
    type: CategoryActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// common error
export const categoryApiResponseError = (actionType: string, error: string): CategoryActionType => ({
    type: CategoryActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getCategories = (params?: any): CategoryActionType => ({
    type: CategoryActionTypes.GET_CATEGORIES,
    payload: params || {},
});

export const getCategoryTree = (): CategoryActionType => ({
    type: CategoryActionTypes.GET_CATEGORY_TREE,
    payload: {},
});

export const getCategoryProducts = (id: number, params?: any): CategoryActionType => ({
    type: CategoryActionTypes.GET_CATEGORY_PRODUCTS,
    payload: { id, ...params },
});

export const createCategory = (data: any): CategoryActionType => ({
    type: CategoryActionTypes.CREATE_CATEGORY,
    payload: data,
});

export const updateCategoryAction = (id: number, data: any): CategoryActionType => ({
    type: CategoryActionTypes.UPDATE_CATEGORY,
    payload: { id, ...data },
});

export const deleteCategoryAction = (id: number): CategoryActionType => ({
    type: CategoryActionTypes.DELETE_CATEGORY,
    payload: { id },
});
